import Navbars from "../Navbar";
import LoginBody from './LoginBody';
export default function SignIn(){
    return <>
        <Navbars/>
        <LoginBody/>
    </>
}